// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUs_container__B9FnG {
  margin: 0 auto;
  padding-top: 50px;
  max-width: 1200px;
  font-family: Arial, sans-serif;
  color: #333;
}

.AboutUs_title__TWw4J {
  text-align: center;
  font-size: 2.5rem;
  color: #444;
  margin-bottom: 10px;
}

.AboutUs_subtitle__swSe0 {
  text-align: center;
  font-size: 1.9rem;
  color: #777;
  margin-bottom: 40px;
}

.AboutUs_section__DII84 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 60px;
  flex-wrap: wrap;
}

.AboutUs_image__bgi9k {
  flex: 1 1;
  max-width: 50%; /* Imaginea ocupă jumătate din lățime */
  text-align: center;
  margin: 10px;
}

.AboutUs_image__bgi9k img {
  max-width: 100%;
  height: auto;
}

.AboutUs_textBlock__T\\+hyP {
  flex: 1 1;
  max-width: 50%; /* Textul ocupă jumătate din lățime */
  padding: 20px;
}

.AboutUs_heading__iUKtV {
  font-size: 1.8rem;
  color: #d20e0e;
  margin-bottom: 20px;
  font-weight: normal; /* Eliminarea fontului îngroșat */
}

.AboutUs_paragraph__tNnvd {
  font-size: 1rem;
  line-height: 1.5;
  color: #333;
}

.AboutUs_bold__gGCDB {
  font-weight: bold;
  color: #d20e0e;
}

.AboutUs_footer__mcc-p {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.AboutUs_offer__ckDFV,
.AboutUs_guarantee__lw9mG {
  flex: 1 1;
  margin: 10px;
}

.AboutUs_subheading__dA0hr {
  font-size: 1.5rem;
  color: #d20e0e;
  margin-bottom: 10px;
}

ul {
  list-style-type: disc; /* Adaugă puncte în fața elementelor <li> */
  padding-left: 20px; /* Adaugă un spațiu pentru alinierea punctelor */
  margin-left: 20px;
}

li {
  font-size: 1rem;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .AboutUs_container__B9FnG {
    flex-direction: column;
    padding-top: 55px;
    margin: 15px;
  }

  .AboutUs_heading__iUKtV {
    font-size: 1.5rem;
    color: #d20e0e;
    margin: 10px;
    font-weight: normal; /* Eliminarea fontului îngroșat */
    margin-top: 25px;
  }

  .AboutUs_image__bgi9k {
    flex: 1 1;
    max-width: 100%; /* Imaginea ocupă jumătate din lățime */
  }

  .AboutUs_subheading__dA0hr {
    font-size: 1.3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutUs/AboutUs.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc,EAAE,uCAAuC;EACvD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,cAAc,EAAE,qCAAqC;EACrD,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB,EAAE,2CAA2C;EAClE,kBAAkB,EAAE,gDAAgD;EACpE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,mBAAmB,EAAE,iCAAiC;IACtD,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,eAAe,EAAE,uCAAuC;EAC1D;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  margin: 0 auto;\n  padding-top: 50px;\n  max-width: 1200px;\n  font-family: Arial, sans-serif;\n  color: #333;\n}\n\n.title {\n  text-align: center;\n  font-size: 2.5rem;\n  color: #444;\n  margin-bottom: 10px;\n}\n\n.subtitle {\n  text-align: center;\n  font-size: 1.9rem;\n  color: #777;\n  margin-bottom: 40px;\n}\n\n.section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 60px;\n  flex-wrap: wrap;\n}\n\n.image {\n  flex: 1;\n  max-width: 50%; /* Imaginea ocupă jumătate din lățime */\n  text-align: center;\n  margin: 10px;\n}\n\n.image img {\n  max-width: 100%;\n  height: auto;\n}\n\n.textBlock {\n  flex: 1;\n  max-width: 50%; /* Textul ocupă jumătate din lățime */\n  padding: 20px;\n}\n\n.heading {\n  font-size: 1.8rem;\n  color: #d20e0e;\n  margin-bottom: 20px;\n  font-weight: normal; /* Eliminarea fontului îngroșat */\n}\n\n.paragraph {\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #333;\n}\n\n.bold {\n  font-weight: bold;\n  color: #d20e0e;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 40px;\n}\n\n.offer,\n.guarantee {\n  flex: 1;\n  margin: 10px;\n}\n\n.subheading {\n  font-size: 1.5rem;\n  color: #d20e0e;\n  margin-bottom: 10px;\n}\n\nul {\n  list-style-type: disc; /* Adaugă puncte în fața elementelor <li> */\n  padding-left: 20px; /* Adaugă un spațiu pentru alinierea punctelor */\n  margin-left: 20px;\n}\n\nli {\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n@media (max-width: 768px) {\n  .container {\n    flex-direction: column;\n    padding-top: 55px;\n    margin: 15px;\n  }\n\n  .heading {\n    font-size: 1.5rem;\n    color: #d20e0e;\n    margin: 10px;\n    font-weight: normal; /* Eliminarea fontului îngroșat */\n    margin-top: 25px;\n  }\n\n  .image {\n    flex: 1;\n    max-width: 100%; /* Imaginea ocupă jumătate din lățime */\n  }\n\n  .subheading {\n    font-size: 1.3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AboutUs_container__B9FnG`,
	"title": `AboutUs_title__TWw4J`,
	"subtitle": `AboutUs_subtitle__swSe0`,
	"section": `AboutUs_section__DII84`,
	"image": `AboutUs_image__bgi9k`,
	"textBlock": `AboutUs_textBlock__T+hyP`,
	"heading": `AboutUs_heading__iUKtV`,
	"paragraph": `AboutUs_paragraph__tNnvd`,
	"bold": `AboutUs_bold__gGCDB`,
	"footer": `AboutUs_footer__mcc-p`,
	"offer": `AboutUs_offer__ckDFV`,
	"guarantee": `AboutUs_guarantee__lw9mG`,
	"subheading": `AboutUs_subheading__dA0hr`
};
export default ___CSS_LOADER_EXPORT___;
